import { InputProps } from "~/components/atoms/Input/Input";
import InputFilterSidebarRange from "~/components/atoms/Input/InputFilterSidebarRange";
import Typo from "~/components/atoms/Typo";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

export interface IFilterSidebarRangeProps {
  label?: string;
  inputMinProps?: InputProps;
  inputMaxProps?: InputProps;
}

const FilterSidebarRange: React.FC<IFilterSidebarRangeProps> = ({
  label,
  inputMinProps,
  inputMaxProps,
}) => {
  return (
    <div className="flex flex-col gap-3">
      {label && (
        <Typo
          tag={ETypoTag.P}
          variant={ETypoVariant.HEADER_16}
          className="font-bold"
        >
          {label}
        </Typo>
      )}
      <div className="flex flex-nowrap items-center gap-3">
        <InputFilterSidebarRange
          form="sideBarRange"
          placeholder="Min"
          className="placeholder: w-full bg-filterSidebarRangeInputBackground text-center"
          {...inputMinProps}
        />
        -
        <InputFilterSidebarRange
          form="sideBarRange"
          placeholder="Max"
          className="placeholder: w-full bg-filterSidebarRangeInputBackground text-center"
          {...inputMaxProps}
        />
      </div>
    </div>
  );
};

export default FilterSidebarRange;
